<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="商户简称" prop="merchantShortname">
          <div class="style">
            <el-input v-model="ruleForm.merchantShortname" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">1、在支付完成页向买家展示，需与微信经营类目相关。</p>
          <p class="labels-tips">2、简称要求：</p>
          <p class="labels-tips">
            ①
            不支持单纯以人名来命名，若为个体户经营，可用“个体户+经营者名称”或“经营者名称+业务”命名，如“个体户张三”或“张三餐饮店”；
          </p>
          <p class="labels-tips">② 不支持无实际意义的文案，如“XX特约商户”、“800”、“XX客服电话XXX”；</p>
        </el-form-item>
        <el-form-item label="客服电话" prop="servicePhone">
          <div class="style">
            <el-input v-model="ruleForm.servicePhone" placeholder="" clearable></el-input>
          </div>
          <p class="labels-tips">1、请填写真实有效的客服电话，将在交易记录中向买家展示，提供咨询服务；</p>
          <p class="labels-tips">2、请确保电话畅通，以便入驻后平台回拨确认。</p>
        </el-form-item>

        <el-form-item label="经营场景" prop="salesScenesType">
          <div class="style">
            <el-checkbox-group v-model="ruleForm.salesScenesType">
              <el-checkbox v-for="item in limit" :label="item.value" :key="item.id" @change="salesScenesTypeFn">{{
                item.title
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <p class="labels-tips">请勾选实际售卖商品/提供服务场景（至少一项），以便为你开通需要的支付权限</p>
          <p class="labels-tips">
            建议只勾选目前必须的场景，以便尽快通过入驻审核，其他支付权限你可在入驻后再根据实际需要发起申请
          </p>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        merchantShortname: '',
        servicePhone: '',
        salesScenesType: [],
      },
      rules: {
        merchantShortname: [{ required: true, message: '请输入商户简称', trigger: ['blur', 'change'] }],
        servicePhone: [{ required: true, message: '请输入客服电话', trigger: ['blur', 'change'] }],
        salesScenesType: [{ required: true, message: '请选择经营场景', trigger: ['blur', 'change'] }],
      },
      limit: [
        {
          id: '0',
          title: '线下门店',
          value: 'SALES_SCENES_STORE',
        },
        {
          id: '1',
          title: '公众号',
          value: 'SALES_SCENES_MP',
        },
        {
          id: '2',
          title: '小程序',
          value: 'SALES_SCENES_MINI_PROGRAM',
        },
        {
          id: '3',
          title: 'APP',
          value: 'SALES_SCENES_APP',
        },
        {
          id: '4',
          title: '互联网网站',
          value: 'SALES_SCENES_WEB',
        },
        {
          id: '5',
          title: '企业微信',
          value: 'SALES_SCENES_WEWORK',
        },
      ],
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = data.businessDataVO;
          this.ruleForm.salesScenesType = data.businessDataVO.salesScenesType.split(',');
          console.log(this.ruleForm.salesScenesType);
          this.salesScenesTypeFn();
        }
      },
    },
  },

  methods: {
    salesScenesTypeFn() {
      this.$emit('salesScenesType', this.ruleForm.salesScenesType);
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}

.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
